import React from "react";
import {
  makeStyles,
  createStyles,
  Theme,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Container,
  FormControlLabel,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "@material-ui/lab";
import { PageDisplay, ColumnBaseHeaderStyle, ColumnBaseCellStyle } from "../../../components";
import { FileCrawlingErrorPaneData } from "../../../types/notification";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
    },
    th: {
      ...ColumnBaseHeaderStyle,
      backgroundColor: theme.palette.background.paper,
    },
    td: ColumnBaseCellStyle,
    td_info: {
      ...ColumnBaseCellStyle,
      color: theme.palette.info.dark,
    },
    td_error: {
      ...ColumnBaseCellStyle,
      color: theme.palette.error.dark,
    },
    tableContainer: {
      marginTop: theme.spacing(1),
    },
    pagination: {
      marginTop: theme.spacing(1),
    },
  })
);

interface Props {
  onChangeOpen: (event: any) => void;
  errorData: FileCrawlingErrorPaneData;
  onChangeCurrentPage: (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => void;
}

/** Fileクロール通知エラーペイン */
export default function FileCrawlingErrorPane(props: Props) {
  const classes = useStyles();

  // 表示切替関連
  const { onChangeOpen } = props;

  // エラー画面関連
  const { errorData } = props;
  const { onChangeCurrentPage } = props;

  //--------------------
  // コンポーネント
  return (
    <div>
      <Container maxWidth="lg">
        <FormControlLabel
          control={(
            <IconButton style={{ fontSize: "1rem" }} onClick={onChangeOpen}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </IconButton>
          )}
          label={<span style={{ fontSize: "0.9rem" }}>戻る</span>}
        />
        <PageDisplay
          fromNumber={(errorData.currentPage - 1) * errorData.displayCount + 1}
          toNumber={
            errorData.currentPage * errorData.displayCount <
            errorData.totalCount
              ? errorData.currentPage * errorData.displayCount
              : errorData.totalCount
          }
          totalNumber={errorData.totalCount}
        />
        <TableContainer component={Paper} style={{ maxHeight: "80vh" }}>
          <Table
            className={classes.table}
            size="small"
            stickyHeader
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell className={classes.th}>No</TableCell>
                <TableCell className={classes.th}>発生日時</TableCell>
                <TableCell className={classes.th}>区分</TableCell>
                <TableCell className={classes.th}>レベル</TableCell>
                <TableCell className={classes.th}>メッセージ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errorData.rows.map((row, i) => (
                <TableRow key={row.id}>
                  <TableCell className={classes.td} component="th" scope="row">
                    {(errorData.currentPage - 1) * errorData.displayCount +
                      i +
                      1}
                  </TableCell>
                  <TableCell className={classes.td}>{row.created_at}</TableCell>
                  <TableCell className={classes.td}>{row.category}</TableCell>
                  <TableCell className={row.level === "エラー" ? classes.td_error : classes.td_info}>{row.level}</TableCell>
                  <TableCell className={classes.td}>{row.message}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          className={classes.pagination}
          count={errorData.totalPage}
          page={errorData.currentPage}
          onChange={onChangeCurrentPage}
        />
      </Container>
    </div>
  );
}
